import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#12263f] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <img src="/vetrich-logo.png" alt="Vetrich Technologies" className="h-10 w-auto object-contain" />
            <span className="font-display font-bold text-base tracking-tight">VETRICH TECHNOLOGIES</span>
          </div>

          <p className="text-sm text-white/60">© 2026 VETRICH TECHNOLOGIES. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <a href="#ayurveda" className="text-sm text-white/70 hover:text-[#c9a227] transition-colors">Shop</a>
            <a href="/admin" className="text-sm text-white/70 hover:text-[#c9a227] transition-colors">Admin Login</a>
          </div>
        </div>
      </div>
      <div className="bg-[#0d1e33] py-3.5">
        <p className="text-center text-xs text-white/40">Powered by Vetrich Technologies</p>
      </div>
    </footer>
  );
};

export default Footer;
